import { ReactComponent as CheckCircle } from "@/assets/svgs/etr-maker-checker-circle.svg";
import { assetUrl } from '@/utils/asset-url';
import { ReactComponent as CheckFilledCircle } from "@/assets/svgs/etr-maker-checker-filled-circle.svg";
import { ReactComponent as IconDoubleCheck } from "@/assets/svgs/icon-check-double.svg";
import { ReactComponent as IconClock } from "@/assets/svgs/icon-clock.svg";
import IconDotted from "@/assets/svgs/icon-dotted.svg";
import { ReactComponent as IconEllipse } from "@/assets/svgs/icon-ellipse.svg";
import { ReactComponent as IconFlag } from "@/assets/svgs/icon-flag.svg";
import { ReactComponent as InfoBadgeFilled } from "@/assets/svgs/icon-info-filled.svg";
import { ReactComponent as IconIndicator } from '@/assets/svgs/indicator.svg';
import { ReactComponent as IconInformationCircle } from "@/assets/svgs/information-circle-colored.svg";
import { ReactComponent as IconConfigure } from "@/assets/svgs/red-info-icon.svg";
import { ReactComponent as IconRecordTransfer } from "@/assets/svgs/transferrable.svg";
import { ReactComponent as WarningIndicator } from '@/assets/svgs/verification-inidicator.svg';
import { ReactComponent as IconXCircle } from "@/assets/svgs/x-circle.svg";
import Button from "@/components/Button/index";
import Tag from "@/components/Tag/index";
import Toast from "@/components/Toast/index";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import VerificationDetails, { VerificationStatus as VerificationStatusType } from "@/componentsDS/VerificationDetails/VerificationDetails";
import { featureConstant } from "@/constants/configuration/feature.js";
import { MAKER_CHECKER_ETR_MODAL_CONTENT, MAKER_CHECKER_ETR_MODAL_CONTENT_V5, etrActionable, etrActions, getIconFillColorType } from "@/constants/etr/etr-action/index";
import toastType from "@/constants/toast-type/index";
import tokenRegistryVersions from "@/constants/token-registry-versions/tokenRegistryVersion";
import tradeTrustType from "@/constants/trade-trust-type/index";
import useConfig from '@/hooks/use-config/index';
import useDid from "@/hooks/use-did/index";
import useEtr from '@/hooks/use-etr/index';
import useModal from "@/hooks/use-modal/index";
import useRecordDetail from "@/hooks/use-record-detail/index";
import useStaticData from "@/hooks/use-static-data/index";
import useToast from "@/hooks/use-toast/index";
import { useNavigate, useParams } from '@/lib/router-dom';
import { getVerificationStatusArray } from "@/pages/record-transfer/record-details-side-panel/components/verificationStatus/verificationStatus.jsx";
import ETR_API from "@/services/api/etr";
import ETR_ISSUANCE_API from '@/services/api/etr-issuance.js';
import GetETRMakerCheckerStatus from '@/utils/etr-maker-checker-status';
import { feature, features } from "@/utils/feature-verifier.js";
import classname from 'classnames';
import { isEqual } from "lodash";
import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import RemarksComponent from "../etr-issuance/record-details/components/remarks-component";
import TokenRegistryDropdown from "../etr-issuance/record-details/components/token-registry-version";
import ActionableButton from "./components/actionable-button/index";
import UpdateWallet from "./components/update-wallet/index";

const RetrievingBlockchainInformation = () => {
	return <div className="blockchain-infor-loading-text">
		Retrieving blockchain information...
	</div>
}

const InformationUnavailable = () => {
	return <div
		data-testid="blockchain-infor-unavail-text"
		className="blockchain-infor-unavail-text">
		Information Unavailable
	</div>
}

const RecordDetailsSidePanel = ({
	etrDocDetails,
	fetchEtrDocumentBlockchainDetails,
	etrDocBlockchainDetails,
	etrDocBlockchainDetailsLoading,
	etrDocErrorMsg,
	isApprovalScreen = false,
	showBackgroundColor = false
}) => {
	const ttData = useSelector((state) => state.tt, isEqual);
	const ttFile = ttData?.file;
	const { profile } = useSelector(state => state.auth);

	const [submitLoading, setSubmitLoading] = useState(false);

	const { goTo } = useNavigate();

	const dataElementId = "ebl"
	const emptyAddress = "0x0000000000000000000000000000000000000000";

	const { toastList, addToastMessage } = useToast()
	const { identity, provideItems, consumeItems, error: errorConfig } = useConfig()
	const { toFindDid, toFindOrgId, toFindOrgName } = useDid()
	const { fetchEtr, etrData } = useEtr({
		dataElementId,
		configData: {
			consumeItems,
			provideItems,
			identity
		}
	})
	const { uploadRecordDetail, recordDetailErrorMsg } = useRecordDetail();
	const { transferableRecordId } = useParams();

	const isETRIGPNITRV5FeatureEnabled = feature(featureConstant?.ETR_IGPNI_TR_V5);

	// Remarks for Transfer Operations
	const [remarksForTransfer, setRemarksForTransfer] = useState("");

	function fetchEtrBlockchainDetails() {
		setSelectedAction(null)
		if (transferableRecordId) {
			fetchEtrDocumentBlockchainDetails(transferableRecordId);
		}
	}

	useEffect(() => {
		fetchEtrBlockchainDetails();
	}, [transferableRecordId]);

	useEffect(() => {
		addToastMessage(recordDetailErrorMsg, toastType.error)
	}, [recordDetailErrorMsg])

	const userOrganizationId = identity?.organization?.id;
	const organizationWallet = toFindDid(userOrganizationId)
	useEffect(() => {
		if ((provideItems || consumeItems) && identity) {
			fetchEtr()
		}
	}, [provideItems, identity, consumeItems])

	useEffect(() => {
		addToastMessage(errorConfig, toastType.error)
	}, [errorConfig])

	const {
		domainName,
		nftRegistry,
		networkLabel,
		verificationFragments,
		tokenRegistryAddress,
		tokenId,
		docData,
		isVerified
	} = ttData?.data ?? {};

	const {
		holder: etrIssuance_holder,
		owner: etrIssuance_owner,
		endorsementChain: etrIssuance_endorsementChain,
		nominatedBeneficiary: etrIssuance_nominatedBeneficiary,
		ttStatus: etrIssuance_ttStatus
	} = etrDocBlockchainDetails ?? {}

	const {
		holder,
		owner,
		endorsementChain,
		nominatedBeneficiary,
		ttStatus,
	} = {
		holder: etrIssuance_holder,
		owner: etrIssuance_owner,
		endorsementChain: etrIssuance_endorsementChain,
		nominatedBeneficiary: etrIssuance_nominatedBeneficiary,
		ttStatus: etrIssuance_ttStatus
	}

	const [selectedAction, setSelectedAction] = useState(null)
	const { contracts } = useStaticData() ?? { contracts: [] };
	const action = useMemo(() => {
		if (!ttStatus) return etrActions.none;

		if (contracts?.some(contract => contract?.contractAddress === etrDocDetails?.contractAddress)
			&& ttStatus === "Surrendered to Issuer") {
			return etrActions.acceptRejectSurrender;
		} else if (organizationWallet === owner && organizationWallet === holder) {
			return ttStatus === "Surrendered to Issuer"
				? etrActions.surrender
				: etrActions.ownerAndHolder;
		} else if (organizationWallet === owner) {
			return etrActions.ownerOnly;
		} else if (organizationWallet === holder && nominatedBeneficiary !== emptyAddress) {
			return etrActions.holderAndEndorseOwner;
		} else if (organizationWallet === holder) {
			return etrActions.holderOnly;
		} else if (ttStatus === "Shredded") {
			return etrActions.shred;
		}

		return etrActions.none;
	}, [ttStatus, owner, holder, organizationWallet, etrDocDetails]);


	const [selectedOwner, setSelectedOwner] = useState(null)
	const [selectedHolder, setSelectedHolder] = useState(null)
	const [isEditRequest, setIsEditRequest] = useState(false)
	const [editRemarks, setEditRemarks] = useState("");
	const [selectedActionForETRTransfer, setSelectedActionForETRTransfer] = useState(null);

	/*=================================================
		Modal
	/================================================*/
	const { visible: confirmTransferModal, show: showTransferModal, hide: hideTransferModal } = useModal()
	const { visible: confirmDiscardModal, show: showDiscardModal, hide: hideDiscardModal } = useModal()
	const { visible: confirmEditRequestModal, show: showEditRequestModal, hide: hideEditRequestModal } = useModal()
	const { visible: editRejectTransferModal, show: showEditRejectTransferModal, hide: hideEditRejectTransferModal } = useModal()
	const isOwnerAndMakerCheckerEnabled = useMemo(() => !isApprovalScreen && GetETRMakerCheckerTransferStatus("owner"), [isApprovalScreen, etrDocDetails?.eventStatus])
	const shouldRenderETRMakerCheckerOwner = useMemo(() => isApprovalScreen && GetETRMakerCheckerTransferApprovalStatus("OWNER", etrDocDetails?.transactionType), [isApprovalScreen, etrDocDetails?.transactionType])

	function shouldShowNFTInformation() {
		const hasNFTRegistryOrLoading = nftRegistry || etrDocBlockchainDetailsLoading;
		if (!hasNFTRegistryOrLoading) return false;

		if (!isETRIGPNITRV5FeatureEnabled) return true;

		const isNotShreddedAndNotSurrenderAccepted =
			ttStatus !== tradeTrustType.shredded &&
			etrDocDetails?.eventStatus !== "SURRENDER_ACCEPTANCE_APPROVED";

		const isSurrenderFailedOrFailedStore =
			etrDocDetails?.status === "SURRENDER_FAILED" ||
			(etrDocDetails?.transferableStores?.[etrDocDetails?.transferableStores?.length - 1]?.status === "FAIL" &&
				etrDocDetails?.eventStatus === "SURRENDER_ACCEPTANCE_APPROVED");

		return isNotShreddedAndNotSurrenderAccepted || isSurrenderFailedOrFailedStore;
	};

	function getOrgName(walletAddress) {
		const orgName = toFindOrgName(walletAddress)
		if (orgName) {
			return orgName
		}

		if (etrData.some(item => item.walletAddress === walletAddress)) {
			return etrData.find((item) => item.walletAddress === walletAddress).name
		}

		return null
	}

	function getAddressBookId(walletAddress) {
		if (etrData.some(item => item.walletAddress === walletAddress)) {
			return etrData.find((item) => item.walletAddress === walletAddress)?.id
		}
	}

	function checkDisabled() {
		if (selectedAction === etrActionable.transferOwnerAndHolder) {
			return (selectedOwner === null || selectedHolder === null || selectedOwner?.id === 'custom' || selectedHolder?.id === 'custom');
		}
		if (selectedAction === etrActionable.transferOwner) {
			return (selectedOwner === null || selectedOwner?.id === 'custom');
		}
		if (selectedAction === etrActionable.transferHolder) {
			return (selectedHolder === null || selectedHolder?.id === 'custom');
		}
		return true;
	}

	const handleNominateNSurrender = useCallback(async (type, tokenRegistryVersion, remarks = "") => {
		try {
			if (submitLoading) {
				return
			}

			setSubmitLoading(true)

			const createPayloadNominateNSurrender = (newBeneficiary, newHolder) => {
				let payload = {
					tokenRegistryAddress: tokenRegistryAddress,
					chainId: docData?.network?.chainId,
					tokenId: tokenId,
					orgId: identity?.organization?.id,
					systemId: identity?.id
				}
				if (newBeneficiary) {
					payload = { ...payload, newBeneficiary }
				}
				if (newHolder) {
					payload = { ...payload, newHolder }
				}
				if (isETRIGPNITRV5FeatureEnabled && tokenRegistryVersion) {
					payload = {
						...payload,
						tokenRegistryVersion: tokenRegistryVersion,
						...(tokenRegistryVersion === "V5" && { remarks: remarks.trim() }),
					};
				}
				payload.transferableRecordId = transferableRecordId;

				return payload
			};

			const handleApiCallNominateNSurrender = async (payload, apiFunc) => {
				const [error] = await apiFunc(payload);
				if (error) {
					setSubmitLoading(false)
					addToastMessage(error?.message ?? 'Failed to endorse/surrender', toastType.error);
					throw error
				}
			}

			let payload;
			let approveSurrenderError;
			let rejectSurrenderError;

			switch (type) {
				case etrActionable.endorseOwner: {
					payload = createPayloadNominateNSurrender(nominatedBeneficiary, null);
					const updatedPayload = {
						...payload,
						newOwnerOrgId: toFindOrgId(nominatedBeneficiary),
						newOwnerAddressBookId: getAddressBookId(nominatedBeneficiary),
						ownerOrgId: toFindOrgId(owner),
						ownerAddress: owner
					}
					await handleApiCallNominateNSurrender(updatedPayload, isEditRequest ? ETR_API.editRequest : ETR_API.endorseOwner);
					break;
				}
				case etrActionable.surrender:
					payload = createPayloadNominateNSurrender(null, null);
					await handleApiCallNominateNSurrender(payload, isEditRequest ? ETR_API.editRequest : ETR_API.surrenderTT);
					break;
				case etrActionable.acceptSurrender:
					payload = createPayloadNominateNSurrender(null, null);
					[approveSurrenderError] = await ETR_API.approveSurrender(transferableRecordId, payload);
					if (approveSurrenderError) {
						setSubmitLoading(false)
						addToastMessage(approveSurrenderError?.message ?? 'Failed to accept surrender', toastType.error);
						throw approveSurrenderError
					}
					break;
				case etrActionable.rejectSurrender:
					payload = createPayloadNominateNSurrender(null, null);
					[rejectSurrenderError] = await ETR_API.rejectSurrender(transferableRecordId, payload);
					if (rejectSurrenderError) {
						setSubmitLoading(false)
						addToastMessage(rejectSurrenderError?.message ?? 'Failed to reject surrender', toastType.error);
						throw rejectSurrenderError
					}
					break;

				default:
					break;
			}
			uploadRecordDetail(ttFile)
			goTo('/record-transfer/success', { type: type, handleTransportResult: true, etrMakerCheckerTransactionName: etrDocDetails?.name, transferableRecordId: transferableRecordId, makerChecker: profile?.organization?.makerChecker })
		} catch (err) {
			console.error('Failed to endorse/surrdener', err)
		} finally {
			setSubmitLoading(false);
		}
	}, [action, etrData, ttData, isEditRequest])

	const handleRejectTransfers = useCallback(async (type, remarks) => {
		if (submitLoading) return;

		setSubmitLoading(true);
		try {
			const apiMap = {
				[etrActionable.rejectTransferOwner]: isEditRequest
					? ETR_API.editRequest
					: ETR_API.rejectTransferOwner,
				[etrActionable.rejectTransferHolder]: isEditRequest
					? ETR_API.editRequest
					: ETR_API.rejectTransferHolder,
				[etrActionable.rejectTransferOwnerHolder]: isEditRequest
					? ETR_API.editRequest
					: ETR_API.rejectTransferOwnerHolder,
			};

			const apiFunc = apiMap[type];
			if (!apiFunc) {
				addToastMessage('Invalid transfer rejection attempt', toastType.error);
				throw new Error('Invalid transfer rejection attempt');
			}

			const payload = {
				transferableRecordId: transferableRecordId,
				remarks: remarks.trim(),
			};
			const [error] = isEditRequest ? await apiFunc(payload) : await apiFunc(transferableRecordId, { remarks: remarks.trim() });

			if (error) {
				addToastMessage(error?.message ?? 'Failed to reject transfer', toastType.error);
				throw error;
			}

			goTo('/record-transfer/success', { type: etrActionable.rejectTransfer, handleTransportResult: true, etrMakerCheckerTransactionName: etrDocDetails?.name, transferableRecordId: transferableRecordId, makerChecker: profile?.organization?.makerChecker });
		} catch (err) {
			console.error('Failed to reject transfer', err);
		} finally {
			setSubmitLoading(false);
		}
	}, [submitLoading, isEditRequest, etrData]);


	function resetTransferDetails() {
		setSelectedAction(null)
		setSelectedOwner(null)
		setSelectedHolder(null)
	}

	// ETR Maker Checker Handle transfer API
	async function ETRMakerCheckerHandleTransfer() {
		try {
			if (submitLoading) {
				return
			}

			setSubmitLoading(true)

			const handleTransferAPI = async (payload, apiFunc) => {
				const [error] = await apiFunc(payload);

				if (error) {
					setSubmitLoading(false)
					addToastMessage(error?.message ?? 'Error while transferring', toastType.error);
					throw error
				}

				return true
			}

			let defaultPpayload = {
				tokenRegistryAddress: tokenRegistryAddress,
				chainId: docData?.network?.chainId,
				tokenId: tokenId,
				orgId: identity?.organization?.id,
				systemId: identity?.id,
				transferableRecordId: transferableRecordId,

				ownerOrgId: toFindOrgId(owner),
				ownerAddress: owner,
				holderOrgId: toFindOrgId(holder),
				holderAddress: holder,
			}
			if (isETRIGPNITRV5FeatureEnabled && etrDocDetails?.tokenRegistryVersion === "V5") {
				defaultPpayload = { ...defaultPpayload, remarks: remarksForTransfer.trim(), tokenRegistryVersion: etrDocDetails?.tokenRegistryVersion }
			}
			if (isETRIGPNITRV5FeatureEnabled && etrDocDetails?.tokenRegistryVersion != "V5") {
				defaultPpayload = { ...defaultPpayload, tokenRegistryVersion: etrDocDetails?.tokenRegistryVersion }
			}
			let payload;

			switch (selectedAction) {
				case etrActionable.transferOwnerAndHolder:
					payload = {
						...defaultPpayload,
						newBeneficiary: selectedOwner.walletAddress,
						newOwnerOrgId: toFindOrgId(selectedOwner.walletAddress),
						newOwnerAddressBookId: getAddressBookId(selectedOwner.walletAddress),
						newHolder: selectedHolder.walletAddress,
						newHolderOrgId: toFindOrgId(selectedHolder.walletAddress),
						newHolderAddressBookId: getAddressBookId(selectedHolder.walletAddress)
					}
					await handleTransferAPI(payload, isEditRequest ? ETR_API.editRequest : ETR_API.endorseOwnerAndHolder);
					break;
				case etrActionable.transferOwner:
					payload = {
						...defaultPpayload,
						newBeneficiary: selectedOwner.walletAddress,
						newOwnerOrgId: toFindOrgId(selectedOwner.walletAddress),
						newOwnerAddressBookId: getAddressBookId(selectedOwner.walletAddress),
					}
					if (action === etrActions.ownerAndHolder) {
						await handleTransferAPI(payload, isEditRequest ? ETR_API.editRequest : ETR_API.transferOwnership);
					} else {
						await handleTransferAPI(payload, isEditRequest ? ETR_API.editRequest : ETR_API.nominateOwner);
					}
					break;
				case etrActionable.transferHolder:
					payload = {
						...defaultPpayload,
						newHolder: selectedHolder.walletAddress,
						newHolderOrgId: toFindOrgId(selectedHolder.walletAddress),
						newHolderAddressBookId: getAddressBookId(selectedHolder.walletAddress),
					}
					await handleTransferAPI(payload, isEditRequest ? ETR_API.editRequest : ETR_API.transferHoldership);
					break;
				default:
					break;
			}

			goTo('/record-transfer/success', { type: selectedAction, handleTransportResult: true, etrMakerCheckerTransactionName: etrDocDetails?.name, transferableRecordId: transferableRecordId, makerChecker: profile?.organization?.makerChecker })
		} catch (err) {
			console.error('Failed to handle transfer:', err);
		} finally {
			setSubmitLoading(false);
		}
	}

	async function handleRetry() {
		const body = {
			transferableRecordId: transferableRecordId,
		};

		setSubmitLoading(true)

		const [error] = await ETR_ISSUANCE_API.retry(body);
		if (error) {
			setSubmitLoading(false);
			addToastMessage(error?.message ?? 'Error while retrying', toastType.error);
			return;
		}
		fetchEtrBlockchainDetails();
		setSubmitLoading(false);
		window.location.reload();
	}

	async function handleDiscardRequest() {
		setSubmitLoading(true)

		const [error] = await ETR_ISSUANCE_API.discardRequest(transferableRecordId);
		if (error) {
			setSubmitLoading(false);
			addToastMessage(error?.message ?? 'Error while discarding request', toastType.error);
			return;
		}
		fetchEtrBlockchainDetails();
		setSubmitLoading(false);
		window.location.reload();
	}

	async function handleRetryRequest() {
		setSubmitLoading(true)

		const [error] = await ETR_ISSUANCE_API.retryRequest(transferableRecordId);
		if (error) {
			setSubmitLoading(false);
			addToastMessage(error?.message ?? 'Error while Retry request', toastType.error);
			return;
		}
		fetchEtrBlockchainDetails();
		setSubmitLoading(false);
		window.location.reload();
	}

	// ETR Maker Checker Transfer Status
	function GetETRMakerCheckerTransferStatus(type) {
		if (type === "owner") {
			return (['OWNER_TRANSFER_PENDING_APPROVAL', 'OWNER_HOLDER_TRANSFER_PENDING_APPROVAL', 'OWNER_HOLDER_TRANSFER_APPROVED', 'OWNER_TRANSFER_APPROVED', 'OWNER_TRANSFER_REJECTED', 'OWNER_TRANSFER_FAILED', 'OWNER_HOLDER_TRANSFER_REJECTED', 'OWNER_HOLDER_TRANSFER_FAILED', 'OWNER_TRANSFER_REJECTION_PENDING_APPROVAL', 'OWNER_HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL', 'OWNER_TRANSFER_REJECTION_APPROVED', 'OWNER_HOLDER_TRANSFER_REJECTION_APPROVED', 'OWNER_TRANSFER_REJECTION_REJECTED', 'OWNER_HOLDER_TRANSFER_REJECTION_REJECTED',
				'OWNER_TRANSFERRING', 'OWNER_HOLDER_TRANSFERRING', 'NOMINATION_PENDING_APPROVAL', 'NOMINATION_APPROVED', 'NOMINATING', 'NOMINATION_REJECTED', 'NOMINATION_FAILED', 'ENDORSEMENT_PENDING_APPROVAL', 'ENDORSEMENT_FAILED', 'ENDORSEMENT_REJECTED'].includes(etrDocDetails?.eventStatus))
		}
		else {
			return (['HOLDER_TRANSFER_PENDING_APPROVAL', 'OWNER_HOLDER_TRANSFER_PENDING_APPROVAL', 'OWNER_HOLDER_TRANSFER_APPROVED', 'HOLDER_TRANSFER_APPROVED', 'HOLDER_TRANSFER_REJECTED', 'HOLDER_TRANSFER_FAILED', 'HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL', 'HOLDER_TRANSFER_REJECTION_APPROVED', 'HOLDER_TRANSFER_REJECTION_REJECTED', 'OWNER_HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL', 'OWNER_HOLDER_TRANSFER_REJECTION_APPROVED', 'OWNER_HOLDER_TRANSFER_REJECTION_REJECTED',
				'OWNER_HOLDER_TRANSFER_REJECTED', 'OWNER_HOLDER_TRANSFER_FAILED', 'HOLDER_TRANSFERRING', 'OWNER_HOLDER_TRANSFERRING'].includes(etrDocDetails?.eventStatus))
		}
	}

	function GetETRMakerCheckerTransferApprovalStatus(type, txnType) {
		if (type === "OWNER") {
			return (['TRANSFER_OWNERSHIP', 'TRANSFER_OWNERSHIP_HOLDERSHIP', 'NOMINATE_OWNERSHIP', "REJECT_OWNER_TRANSFER", "REJECT_OWNER_HOLDER_TRANSFER"].includes(txnType))
		}
		else {
			return (['TRANSFER_HOLDERSHIP', 'TRANSFER_OWNERSHIP_HOLDERSHIP', "REJECT_HOLDER_TRANSFER", "REJECT_OWNER_HOLDER_TRANSFER"].includes(txnType))
		}
	}

	function editETRRequest(status) {
		setIsEditRequest(true)
		const transferHolderData = etrData?.find(item => item.walletAddress === etrDocDetails?.transferableStores[etrDocDetails?.transferableStores.length - 1]?.newHolderAddress);
		const transferOwnerData = etrData?.find(item => item.walletAddress === etrDocDetails?.transferableStores[etrDocDetails?.transferableStores.length - 1]?.newOwnerAddress);
		const oldRemarksData = etrDocDetails?.transferableStores[etrDocDetails?.transferableStores.length - 1]?.remarks;

		if (status === "OWNER_TRANSFER_REJECTED" || status === "NOMINATION_REJECTED") {
			setSelectedOwner(transferOwnerData)
			setSelectedAction(etrActionable.transferOwner)
		}

		else if (status === "HOLDER_TRANSFER_REJECTED") {
			setSelectedHolder(transferHolderData)
			setSelectedAction(etrActionable.transferHolder)
		}

		else if (status === "OWNER_HOLDER_TRANSFER_REJECTED") {
			setSelectedOwner(transferOwnerData)
			setSelectedHolder(transferHolderData)
			setSelectedAction(etrActionable.transferOwnerAndHolder)
		}

		else if (status === "OWNER_HOLDER_TRANSFER_REJECTION_REJECTED" || status === "OWNER_TRANSFER_REJECTION_REJECTED" || status === "HOLDER_TRANSFER_REJECTION_REJECTED") {
			const statusActionMap = {
				OWNER_HOLDER_TRANSFER_REJECTION_REJECTED: etrActionable.rejectTransferOwnerHolder,
				OWNER_TRANSFER_REJECTION_REJECTED: etrActionable.rejectTransferOwner,
				HOLDER_TRANSFER_REJECTION_REJECTED: etrActionable.rejectTransferHolder,
			};
			setSelectedActionForETRTransfer(statusActionMap[status]);
			setIsEditRequest(true);
			setEditRemarks(oldRemarksData);
			showEditRejectTransferModal();
		}
	}
	const getETRStatuses = () => {
		if (etrDocBlockchainDetailsLoading) {
			return <RetrievingBlockchainInformation />;
		} else if (!nftRegistry) {
			return (
				<div data-testid="verifiable" className="icon_user_group">
					<div className="icon_user_group__margin__right">
						<IconDoubleCheck />
					</div>
					Verifiable
				</div>
			);
		} else {
			const { component } = GetETRMakerCheckerStatus({
				eventStatus: etrDocDetails?.eventStatus?.toLowerCase() ?? null,
				status: etrDocDetails?.status?.toLowerCase() ?? null,
				transactionType: etrDocDetails?.transactionType,
				isApprovalScreen: isApprovalScreen,
				transferableStoreType:
					etrDocDetails?.transferableStores[
						etrDocDetails?.transferableStores?.length - 1
					]?.type,
				action: action,
				beneficiaryInfo: {
					nominatedBeneficiary,
					emptyAddress
				},
				storeStatus: etrDocDetails?.transferableStores[etrDocDetails?.transferableStores?.length - 1]?.status?.toLowerCase()
			});
			return component;
		}
	};

	const GetStatus = () => {
		if (etrDocErrorMsg) {
			return (
				<div data-testid="no-status" className="no-status-text">
					No Status
				</div>
			);
		}
		if (etrDocBlockchainDetailsLoading) {
			return <RetrievingBlockchainInformation />
		} else {
			if (ttStatus === tradeTrustType.unknown) {
				return (
					<Tag
						data-testid="unsupported"
						icon={<IconInformationCircle fill='#60636B' />}
						padding={false}
						color="grey"
						theme="light"
						background="transparent"
					>
						Unsupported
					</Tag>
				);
			}
			if (!nftRegistry) {
				return (
					<div data-testid="verifiable" className="icon_user_group">
						<div className="icon_user_group__margin__right">
							<IconDoubleCheck />
						</div>
						Verifiable
					</div>
				)
			}
			if (ttStatus === tradeTrustType.active) {
				if (nftRegistry) {
					return (
						<div data-testid="transferrable" className="icon_user_group">
							<div className="icon_record__margin__right">
								<IconRecordTransfer />
							</div>
							Transferrable
						</div>
					)
				}
			}
			if (ttStatus === tradeTrustType.surrendertoIssuer) {
				return (
					<div data-testid="surrendered" className="icon_user_group icon_user_group--surrendered">
						<div className="icon_user_group__margin__right">
							<IconFlag />
						</div>
						{"Surrendered to Issuer"}
					</div>
				)
			}
			if (ttStatus === tradeTrustType.shredded) {
				return (
					<Tag
						data-testid="shredded"
						icon={<IconXCircle />}
						round
						color="grey"
						theme="light"
						background="white"
					>
						Shredded
					</Tag>
				)
			}
			return <></>
		}
	}

	const Issuer = () => {
		if (ttStatus === tradeTrustType.unknown) {
			return <InformationUnavailable />
		} else if (!domainName) {
			return <RetrievingBlockchainInformation />
		} else {
			return <div
				className="issuer_name__color__secondary"
				data-testid="issuer_name__color__secondary"
			>
				{domainName.toUpperCase()}
			</div>
		}
	}

	const issuerName = () => {
		if (ttStatus === tradeTrustType.unknown) {
			return "Information Unavailable"
		} else if (!domainName) {
			return "Retrieving blockchain information..."
		} else {
			return domainName.toUpperCase()
		}
	}

	const NFTInformation = () => {
		let isDisabled = isApprovalScreen && ["APPROVED", "REJECTED"].includes(etrDocDetails?.status)
		const hrefValue = !isDisabled ? nftRegistry : '#';
		if (ttStatus === tradeTrustType.unknown) {
			return <InformationUnavailable />
		} else if (etrDocBlockchainDetailsLoading) {
			return <RetrievingBlockchainInformation />
		} else if (nftRegistry) {
			return <>
				<a
					href={hrefValue}
					target="_blank"
					rel="noopener noreferrer"
					className="nftRegistry"
				>
					NFT Registry
				</a>
				<div
					className="endorsement_chain_div"
					onClick={() => {
						if (isDisabled) return;
						feature(features.TT_HOTFIX) || isETRIGPNITRV5FeatureEnabled ? goTo(`/record-transfer/record-details/${transferableRecordId}/endorsement-chain`, { transferableRecordId, etrDocDetails }) : goTo(`/record-transfer/record-details/${transferableRecordId}/endorsement-chain`, { endorsementChain, });
					}}
				>
					Endorsement Chain
				</div>
			</>
		}
		return <></>
	}

	const RecordDetailsManageButton = () => {
		if (ttStatus === tradeTrustType.shredded || etrDocBlockchainDetailsLoading) {
			return <></>
		} else if (etrDocDetails?.status === "ISSUANCE_FAILED") {
			return <Button
				data-testid={"retry-button"}
				text="Retry"
				ghost
				loading={submitLoading}
				submit={handleRetry}
			/>
		} else if (etrDocDetails?.eventStatus === "OWNER_TRANSFER_FAILED" || etrDocDetails?.eventStatus === "HOLDER_TRANSFER_FAILED" || etrDocDetails?.eventStatus === "OWNER_HOLDER_TRANSFER_FAILED" || etrDocDetails?.eventStatus === "NOMINATION_FAILED" || etrDocDetails?.eventStatus === "ENDORSEMENT_FAILED" || etrDocDetails?.status === "SURRENDER_FAILED" || etrDocDetails?.eventStatus === "OWNER_TRANSFER_REJECTION_FAILED" || etrDocDetails?.eventStatus === "HOLDER_TRANSFER_REJECTION_FAILED" || etrDocDetails?.status === "OWNER_HOLDER_TRANSFER_REJECTION_FAILED" || (etrDocDetails?.transferableStores[etrDocDetails?.transferableStores?.length - 1]?.status === "FAIL" && etrDocDetails?.eventStatus === "SURRENDER_ACCEPTANCE_APPROVED")) {
			return <div>
				<Button
					data-testid={"retry-button"}
					text="Retry"
					round
					addClass={"etr-maker-checker__retry-button"}
					loading={submitLoading}
					submit={handleRetryRequest}
				/>
				<Button
					data-testid={"discard-request-button"}
					warning
					text="Discard Request"
					round
					addClass={"etr-maker-checker__discard-button"}
					loading={submitLoading}
					submit={showDiscardModal}
				/>
			</div>
		} else if (!isEditRequest && (etrDocDetails?.eventStatus === "OWNER_TRANSFER_REJECTED" || etrDocDetails?.eventStatus === "HOLDER_TRANSFER_REJECTED" || etrDocDetails?.eventStatus === "OWNER_HOLDER_TRANSFER_REJECTED" || etrDocDetails?.eventStatus === "NOMINATION_REJECTED" || etrDocDetails?.eventStatus === "ENDORSEMENT_REJECTED" || etrDocDetails?.eventStatus === "SURRENDER_REJECTED" || etrDocDetails?.eventStatus === "OWNER_TRANSFER_REJECTION_REJECTED" || etrDocDetails?.eventStatus === "HOLDER_TRANSFER_REJECTION_REJECTED" || etrDocDetails?.eventStatus === "OWNER_HOLDER_TRANSFER_REJECTION_REJECTED")) {
			return <div>
				{etrDocDetails?.eventStatus !== "SURRENDER_REJECTED" && <Button
					text="Edit Request"
					round
					addClass={"etr-maker-checker__retry-button"}
					submit={() => editETRRequest(etrDocDetails?.eventStatus)}
				/>}
				<Button
					data-testid={"discard-request-button"}
					warning
					text="Discard Request"
					round
					addClass={"etr-maker-checker__discard-button"}
					loading={submitLoading}
					submit={showDiscardModal}
				/>
			</div>
		} else if (etrDocErrorMsg?.toLowerCase()?.includes('timeout')) {
			return <Button
				data-testid={"reload-button"}
				text="Retry"
				ghost
				loading={submitLoading}
				submit={fetchEtrBlockchainDetails}
			/>
		} else if (action !== etrActions.none) {
			return <ActionableButton
				etrDocDetails={etrDocDetails}
				setAction={setSelectedAction}
				checkAction={action}
				hasNominatedBeneficiary={nominatedBeneficiary !== emptyAddress}
				handleNominateNSurrender={handleNominateNSurrender}
				handleRejectTransfers={handleRejectTransfers}
				isEditRequest={isEditRequest}
				setIsEditRequest={setIsEditRequest}
				setRemarksForTransfer={setRemarksForTransfer}
			/>
		}
		return <></>
	}

	const renderMakerCheckerEnabledOwner = () => {
		const isNotHolderAndEndorse = action !== etrActions.holderAndEndorseOwner;
		const isHolderAndEndorse = action === etrActions.holderAndEndorseOwner || (nominatedBeneficiary && nominatedBeneficiary !== emptyAddress) && !etrDocBlockchainDetailsLoading;
		const etrMakerCheckerContainerClass = classname({
			'etr-maker-checker__container-pending': ["OWNER_TRANSFER_PENDING_APPROVAL", "OWNER_HOLDER_TRANSFER_PENDING_APPROVAL", "OWNER_TRANSFER_REJECTION_PENDING_APPROVAL", "OWNER_HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL", "NOMINATION_PENDING_APPROVAL", "ENDORSEMENT_PENDING_APPROVAL"].includes(etrDocDetails?.eventStatus),
			'etr-maker-checker__container-transferring': ["OWNER_TRANSFERRING", "OWNER_HOLDER_TRANSFERRING", "OWNER_TRANSFER_APPROVED", "OWNER_HOLDER_TRANSFER_APPROVED", "OWNER_TRANSFER_REJECTION_APPROVED", "OWNER_HOLDER_TRANSFER_REJECTION_APPROVED"].includes(etrDocDetails?.eventStatus),
			'etr-maker-checker__container-rejected-failed': ["OWNER_TRANSFER_REJECTED", "OWNER_TRANSFER_FAILED", "OWNER_HOLDER_TRANSFER_REJECTED", "OWNER_HOLDER_TRANSFER_FAILED", "OWNER_TRANSFER_REJECTION_FAILED", "OWNER_HOLDER_TRANSFER_REJECTION_FAILED", "OWNER_TRANSFER_REJECTION_REJECTED", "OWNER_HOLDER_TRANSFER_REJECTION_REJECTED", "NOMINATION_FAILED", "NOMINATION_REJECTED", "ENDORSEMENT_FAILED", "ENDORSEMENT_REJECTED"].includes(etrDocDetails?.eventStatus),
			'etr-maker-checker__container-approved': ["APPROVED"].includes(etrDocDetails?.status) && GetETRMakerCheckerTransferApprovalStatus("OWNER", etrDocDetails?.transactionType),
			'etr-maker-checker__container-rejected': ["REJECTED"].includes(etrDocDetails?.status) && GetETRMakerCheckerTransferApprovalStatus("OWNER", etrDocDetails?.transactionType),
		})
		const previousOwner = etrDocDetails?.transferableStores?.[etrDocDetails.transferableStores.length - 1]?.prevOwnerAddress || null;
		const orgName = getOrgName(previousOwner) ?? null;
		const transferOwner = etrDocDetails?.transferableStores?.[etrDocDetails.transferableStores.length - 1]?.newOwnerAddress || null;
		const transferOrgName = getOrgName(transferOwner) ?? null;
		const iconFillColorType = getIconFillColorType(isApprovalScreen, etrDocDetails?.eventStatus, etrDocDetails?.status);
		const nominatedBeneficiaryOrgName = getOrgName(nominatedBeneficiary) ?? null;
		let currentOwner = previousOwner;

		if (ttStatus === tradeTrustType.shredded) {
			return <></>
		} else if (isHolderAndEndorse) {
			return (
				<div
					className={etrMakerCheckerContainerClass}
					data-testid="owner_container"
				>
					<div className="etr-maker-checker__owner_title__margin__btm etr__update-wallet__title">
						Owner:{" "}
						{(etrDocDetails?.transactionType ===
							"TRANSFER_OWNERSHIP" ||
							(!isApprovalScreen &&
								[
									"ENDORSEMENT_PENDING_APPROVAL",
									"ENDORSEMENT_FAILED",
									"ENDORSEMENT_REJECTED",
								].includes(etrDocDetails?.eventStatus))) && (
								<span className="etr-data-list-status-nominated">
									<IconClock />
									{" Endorsement"}
								</span>
							)}
					</div>
					<div className="etr-maker-checker-view-request-log">
						<div className="etr-maker-checker-view-request-log-icon">
							<CheckCircle />
						</div>
						<div>
							{orgName !== null && (
								<div className="etr__update-wallet__upper etr-maker-checker__update-wallet__text">
									{orgName}{" "}
									{currentOwner === organizationWallet && (!isApprovalScreen) && (
										<span className="etr__update-wallet__text--subtitle">
											(Your Address)
										</span>
									)}
								</div>
							)}
							<div
								className="etr-maker-checker-owner_detail"
								data-testid="owner_detail"
							>
								{currentOwner}
							</div>
						</div>
					</div>
					<div className="etr-maker-checker-view-request-log">
						<div
							className={`etr-maker-checker-view-request-log-icon etr-maker-checker-view-request-log-icon--${iconFillColorType}`}
						>
							<CheckFilledCircle />
						</div>
						<div>
							<div className="etr__update-wallet__upper etr-maker-checker__update-wallet__text">
								{nominatedBeneficiaryOrgName !== null &&
									nominatedBeneficiaryOrgName}{" "}
								{nominatedBeneficiary ===
									organizationWallet && (!isApprovalScreen) && (
										<span className="etr__update-wallet__text--subtitle">
											(Your Address)
										</span>
									)}
							</div>
							<div
								className="etr-maker-checker-owner_detail"
								data-testid="owner_detail"
							>
								{nominatedBeneficiary}
							</div>
						</div>
					</div>
				</div>
			);
		} else if (isNotHolderAndEndorse) {
			if (etrDocBlockchainDetailsLoading) {
				return <div className="record_details_title__new" data-testid="owner_container">
					<div className="owner_title__margin__btm">Owner:</div>
					<RetrievingBlockchainInformation />
				</div>
			} else if (ttStatus === tradeTrustType.unknown) {
				return <div className="record_details_title__new" data-testid="owner_container">
					<div className="owner_title__margin__btm">Owner:</div>
					<InformationUnavailable />
				</div>
			} else {
				return <div className={etrMakerCheckerContainerClass} data-testid="owner_container">
					<div className="etr-maker-checker__owner_title__margin__btm etr__update-wallet__title">Owner: {" "}
						{etrDocDetails?.transferableStore?.type ===
							"ENDORSE_OWNER" && (
								<span className="etr-data-list-status-nominated">
									<IconClock /> Endorsement
								</span>
							)}
					</div>
					<div className="etr-maker-checker-view-request-log">
						<div className="etr-maker-checker-view-request-log-icon"><CheckCircle /></div>
						<div>
							{orgName !== null && (
								<div className="etr__update-wallet__upper etr-maker-checker__update-wallet__text">
									{orgName}{" "}
									{currentOwner === organizationWallet && (!isApprovalScreen) && (
										<span className="etr__update-wallet__text--subtitle">
											(Your Address)
										</span>
									)}
								</div>
							)}
							<div className="etr-maker-checker-owner_detail" data-testid="owner_detail">
								{currentOwner}
							</div>
						</div>
					</div>
					<div className="etr-maker-checker-view-request-log">
						<div className={`etr-maker-checker-view-request-log-icon etr-maker-checker-view-request-log-icon--${iconFillColorType}`}><CheckFilledCircle /></div>
						<div>
							{transferOrgName !== null && (
								<div className="etr__update-wallet__upper etr-maker-checker__update-wallet__text">
									{transferOrgName}{" "}
									{transferOwner === organizationWallet && (!isApprovalScreen) && (
										<span className="etr__update-wallet__text--subtitle">
											(Your Address)
										</span>
									)}
								</div>
							)}
							<div className="etr-maker-checker-owner_detail" data-testid="owner_detail">
								{transferOwner}
							</div>
						</div>
					</div>
				</div>
			}
		}
	}

	const renderOwner = () => {
		if (ttStatus === tradeTrustType.shredded) {
			return <></>
		} else if ((
			action === etrActions.holderAndEndorseOwner ||
			(nominatedBeneficiary && nominatedBeneficiary !== emptyAddress)
		) && !etrDocBlockchainDetailsLoading && !isApprovalScreen) {
			return <div className="endorsement_container" data-testid="owner_container">
				<div className="etr__update-wallet__title">
					Owner: <span className={"etr-data-list-status-nominated"}>
						<IconClock /> Pending Transfer Endorsement
					</span>
				</div>
				<div className="etr__update-wallet__content">
					<div className="etr__update-wallet__section etr__update-wallet__top">
						<div className="etr__update-wallet__left">
							<IconEllipse />
							<div className="etr__update-wallet__line"
								style={{ backgroundImage: `url(${IconDotted})` }}
							>
							</div>
						</div>
						<div className="etr__update-wallet__right">
							<div className="etr__update-wallet__upper etr__update-wallet__text">
								{(getOrgName(owner) !== null) && (
									<div className="etr__update-wallet__upper etr__update-wallet__text">
										{getOrgName(owner)} {owner === organizationWallet && (!isApprovalScreen) && (
											<>
												<span className="etr__update-wallet__text--subtitle">(Your Address)</span>
											</>
										)}
									</div>
								)}
							</div>
							<div className="etr__update-wallet__text--subtitle">
								{owner}
							</div>
						</div>
					</div>
					<div className="etr__update-wallet__section etr__update-wallet__bottom">
						<div className="etr__update-wallet__left etr__update-wallet__left--active">
							<IconEllipse />
						</div>
						<div className="etr__update-wallet__right">
							<div className="etr__update-wallet__upper etr__update-wallet__text">
								<div className="etr__update-wallet__upper etr__update-wallet__text">
									{(getOrgName(nominatedBeneficiary) !== null) && (
										<>
											{getOrgName(nominatedBeneficiary)}
										</>
									)}

									{nominatedBeneficiary === organizationWallet && (!isApprovalScreen) && (
										<>
											<span className="etr__update-wallet__text--subtitle"> (Your Address)</span>
										</>
									)}
								</div>
							</div>
							<div className="etr__update-wallet__text--subtitle" data-testid='nominatedBeneficiary_detail'>
								{nominatedBeneficiary}
							</div>
						</div>
					</div>
				</div>
			</div>
		} else if (action !== etrActions.holderAndEndorseOwner) {
			const Owner = () => {
				if (etrDocBlockchainDetailsLoading) {
					return <RetrievingBlockchainInformation />
				} else if (ttStatus === tradeTrustType.unknown) {
					return <InformationUnavailable />
				} else {
					const orgName = getOrgName(owner) ?? null;
					return <>
						{orgName !== null && (
							<div className="etr__update-wallet__upper etr__update-wallet__text">
								{orgName}{" "}
								{owner === organizationWallet && (!isApprovalScreen) && (
									<span className="etr__update-wallet__text--subtitle">
										(Your Address)
									</span>
								)}
							</div>
						)}
						<div className="owner_detail" data-testid="owner_detail">
							{owner}
						</div>
					</>
				}
			}

			return (
				<div className="record_details_title__new" data-testid="owner_container">
					<div className="owner_title__margin__btm">Owner:</div>
					<Owner />
				</div>
			);
		}
	}

	const renderHolder = () => {
		let approvalCtxConclusiveHolderStatuses = ["HOLDER_TRANSFER_APPROVED", "OWNER_HOLDER_TRANSFER_APPROVED", "HOLDER_TRANSFER_REJECTED", "HOLDER_TRANSFER_FAILED", "OWNER_HOLDER_TRANSFER_REJECTED", "OWNER_HOLDER_TRANSFER_FAILED", "HOLDER_TRANSFERRING", "OWNER_HOLDER_TRANSFERRING", "HOLDER_TRANSFERRED", "OWNER_HOLDER_TRANSFERRED", "NOMINATION_PENDING_APPROVAL", "HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL", "OWNER_HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL", "HOLDER_TRANSFER_REJECTION_REJECTED", "OWNER_HOLDER_TRANSFER_REJECTION_REJECTED", "HOLDER_TRANSFER_REJECTION_FAILED", "OWNER_HOLDER_TRANSFER_REJECTION_FAILED", "HOLDER_TRANSFER_REJECTION_APPROVED", "OWNER_HOLDER_TRANSFER_REJECTION_APPROVED"];
		const previousHolder = etrDocDetails?.transferableStores?.[etrDocDetails?.transferableStores?.length - 1]?.prevHolderAddress || null;
		let currentHolder = isApprovalScreen && approvalCtxConclusiveHolderStatuses.includes(etrDocDetails?.eventStatus) ? previousHolder : holder;

		if (ttStatus === tradeTrustType.shredded) {
			return <></>
		}

		const Holder = () => {
			if (etrDocBlockchainDetailsLoading) {
				return <RetrievingBlockchainInformation />
			} else if (ttStatus === tradeTrustType.unknown) {
				return <InformationUnavailable />
			} else {
				const orgName = getOrgName(isApprovalScreen && approvalCtxConclusiveHolderStatuses.includes(etrDocDetails?.eventStatus) ? previousHolder : holder) ?? null;
				return <>
					{orgName !== null && (
						<div className="etr__update-wallet__upper etr__update-wallet__text">
							{orgName}{" "}
							{currentHolder === organizationWallet && (!isApprovalScreen) && (
								<span className="etr__update-wallet__text--subtitle">
									(Your Address)
								</span>
							)}
						</div>
					)}
					<div className="holder_detail" data-testid="holder_detail" >
						{currentHolder}
					</div >
				</>
			}
		}

		const ETRMakerCheckerHolder = () => {
			if (etrDocBlockchainDetailsLoading) {
				return <div className="record_details_title__new" data-testid="holder_container">
					<div className="holder_title__margin__btm">Holder:</div>
					<RetrievingBlockchainInformation />
				</div>
			} else if (ttStatus === tradeTrustType.unknown) {
				return <div className="record_details_title__new" data-testid="holder_container">
					<div className="holder_title__margin__btm">Holder:</div>
					<InformationUnavailable />
				</div>
			} else {
				const transferPrevHolder = etrDocDetails?.transferableStores?.[etrDocDetails?.transferableStores?.length - 1]?.prevHolderAddress || null;
				const transferHolder = etrDocDetails?.transferableStores?.[etrDocDetails?.transferableStores?.length - 1]?.newHolderAddress || null;
				const transferPrevOrgName = getOrgName(transferPrevHolder) ?? null;
				const transferOrgName = getOrgName(transferHolder) ?? null;
				const iconFillColorType = getIconFillColorType(isApprovalScreen, etrDocDetails?.eventStatus, etrDocDetails?.status);

				const etrMakerCheckerContainerClass = classname({
					'etr-maker-checker__container-pending': ["HOLDER_TRANSFER_PENDING_APPROVAL", "OWNER_HOLDER_TRANSFER_PENDING_APPROVAL", "HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL", "OWNER_HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL"].includes(etrDocDetails?.eventStatus),
					'etr-maker-checker__container-transferring': ["HOLDER_TRANSFERRING", "OWNER_HOLDER_TRANSFERRING", "HOLDER_TRANSFER_APPROVED", "OWNER_HOLDER_TRANSFER_APPROVED", "HOLDER_TRANSFER_REJECTION_APPROVED", "OWNER_HOLDER_TRANSFER_REJECTION_APPROVED"].includes(etrDocDetails?.eventStatus),
					'etr-maker-checker__container-rejected-failed': ["HOLDER_TRANSFER_REJECTED", "HOLDER_TRANSFER_FAILED", "OWNER_HOLDER_TRANSFER_REJECTED", "OWNER_HOLDER_TRANSFER_FAILED", "HOLDER_TRANSFER_REJECTION_REJECTED", "OWNER_HOLDER_TRANSFER_REJECTION_REJECTED", "HOLDER_TRANSFER_REJECTION_FAILED", "OWNER_HOLDER_TRANSFER_REJECTION_FAILED"].includes(etrDocDetails?.eventStatus),
					'etr-maker-checker__container-approved': ["APPROVED"].includes(etrDocDetails?.status) && GetETRMakerCheckerTransferApprovalStatus("HOLDER", etrDocDetails?.transactionType),
					'etr-maker-checker__container-rejected': ["REJECTED"].includes(etrDocDetails?.status) && GetETRMakerCheckerTransferApprovalStatus("HOLDER", etrDocDetails?.transactionType),
				});

				return <div className={etrMakerCheckerContainerClass} data-testid="holder_container">
					<div className="etr-maker-checker__owner_title__margin__btm etr__update-wallet__title">Holder:</div>
					<div className="etr-maker-checker-view-request-log">
						<div className="etr-maker-checker-view-request-log-icon"><CheckCircle /></div>
						<div>
							{transferPrevOrgName !== null && (
								<div className="etr__update-wallet__upper etr-maker-checker__update-wallet__text">
									{transferPrevOrgName}{" "}
									{transferPrevHolder === organizationWallet && (!isApprovalScreen) && (
										<span className="etr__update-wallet__text--subtitle">
											(Your Address)
										</span>
									)}
								</div>
							)}
							<div className="etr-maker-checker-owner_detail" data-testid="holder_detail">
								{transferPrevHolder}
							</div>
						</div>
					</div>
					<div className="etr-maker-checker-view-request-log">
						<div className={`etr-maker-checker-view-request-log-icon etr-maker-checker-view-request-log-icon--${iconFillColorType}`}><CheckFilledCircle /></div>
						<div>
							{transferOrgName !== null && (
								<div className="etr__update-wallet__upper etr-maker-checker__update-wallet__text">
									{transferOrgName}{" "}
									{transferHolder === organizationWallet && (!isApprovalScreen) && (
										<span className="etr__update-wallet__text--subtitle">
											(Your Address)
										</span>
									)}
								</div>
							)}
							<div className="etr-maker-checker-owner_detail" data-testid="holder_detail">
								{transferHolder}
							</div>
						</div>
					</div>
				</div>
			}
		}

		const isHolderAndMakerCheckerEnabled = !isApprovalScreen && GetETRMakerCheckerTransferStatus("holder");
		const shouldRenderETRMakerCheckerHolder = isApprovalScreen && GetETRMakerCheckerTransferApprovalStatus("HOLDER", etrDocDetails?.transactionType);

		if (isHolderAndMakerCheckerEnabled || shouldRenderETRMakerCheckerHolder) {
			return <ETRMakerCheckerHolder />;
		} else {
			return (
				<div className="record_details_title__new" data-testid="holder_container">
					<div className="holder_title__margin__btm">Holder:</div>
					<Holder />
				</div>
			);
		}
	}

	const renderModalHeaderAndContent = () => {
		let headerTitle = "";
		let bodyContent = "";
		const { TRANSFER_OWNERSHIP, NOMINATE_OWNER, TRANSFER_HOLDER, TRANSFER_OWNERSHIP_HOLDERSHIP } = isETRIGPNITRV5FeatureEnabled ? MAKER_CHECKER_ETR_MODAL_CONTENT_V5 : MAKER_CHECKER_ETR_MODAL_CONTENT;
		switch (selectedAction) {
			case etrActionable.transferOwner:
				if (action === etrActions.ownerAndHolder) {
					headerTitle = TRANSFER_OWNERSHIP.header;
					bodyContent = TRANSFER_OWNERSHIP.body;
				} else {
					headerTitle = NOMINATE_OWNER.header;
					bodyContent = NOMINATE_OWNER.body;
				}
				break;
			case etrActionable.transferHolder:
				headerTitle = TRANSFER_HOLDER.header;
				bodyContent = TRANSFER_HOLDER.body;
				break;
			case etrActionable.transferOwnerAndHolder:
				headerTitle = TRANSFER_OWNERSHIP_HOLDERSHIP.header;
				bodyContent = TRANSFER_OWNERSHIP_HOLDERSHIP.body;
				break;
			default:
				break;
		}

		return (
			<>
				{!isETRIGPNITRV5FeatureEnabled ? <CardConfigure.Header>
					<CardConfigure.Header.Icon>
						<IconIndicator />
					</CardConfigure.Header.Icon>
					<CardConfigure.Header.Title>
						{headerTitle}
					</CardConfigure.Header.Title>
				</CardConfigure.Header> :
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className="card-configure__approval-screen__icon"><IconConfigure /></div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">{headerTitle}</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>}
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="etr__modal__content">
							{bodyContent}
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
			</>
		);
	};

	const checkETRtransferableStoreStatus = () => {
		const { itemStatus } = GetETRMakerCheckerStatus({
			eventStatus: etrDocDetails?.eventStatus?.toLowerCase() ?? null,
			status: etrDocDetails?.status?.toLowerCase() ?? null,
			transactionType: etrDocDetails?.transactionType,
			isApprovalScreen: isApprovalScreen,
			transferableStoreType:
				etrDocDetails?.transferableStores[
					etrDocDetails?.transferableStores?.length - 1
				]?.type,
			action: action,
			beneficiaryInfo: {
				nominatedBeneficiary,
				emptyAddress
			},
			storeStatus: etrDocDetails?.transferableStores[etrDocDetails?.transferableStores?.length - 1]?.status?.toLowerCase()
		});

		return itemStatus?.includes("ing") || itemStatus?.includes("pending_approval") || etrDocDetails?.transferableStores[etrDocDetails?.transferableStores?.length - 1]?.status === "FAIL";
	}
	return (
		<>
			<div
				className="record_details_side_panel__flex"
				data-testid="record_details_side_panel__flex"
			>
				<div className="record_details_header__color__purple">
					Record Details
				</div>
				{[
					null,
					etrActionable.surrender,
					etrActionable.endorseOwner,
				].includes(selectedAction) && (
						<>
							<div className={etrDocErrorMsg ? 'status_container__flex status_container__error' : 'status_container__flex'} data-testid="status_container">
								<div className="status_title record_details_title__new">
									Status:
								</div>
								<div className={'status_label_container status_label_container__flex'}>
									{etrDocDetails ? getETRStatuses() : (
										<GetStatus />
									)}
								</div>
							</div>

							{![
								tradeTrustType.unknown,
								...(isETRIGPNITRV5FeatureEnabled ? [tradeTrustType.shredded] : [])
							].includes(ttStatus) && etrDocDetails?.type && (!isETRIGPNITRV5FeatureEnabled || (isETRIGPNITRV5FeatureEnabled && etrDocDetails?.eventStatus !== "SURRENDER_ACCEPTANCE_APPROVED" || (etrDocDetails?.transferableStores[etrDocDetails?.transferableStores?.length - 1]?.status === "FAIL" && etrDocDetails?.eventStatus == "SURRENDER_ACCEPTANCE_APPROVED"))) && (
									<VerificationDetails
										status={isVerified ? VerificationStatusType.SUCCESS : VerificationStatusType.FAILURE}
										issuer={issuerName()}
										learnMore={() => {
											window.open('https://docs.tradetrust.io/docs/introduction/what-is-tradetrust', '_blank', 'noopener,noreferrer');
										}}
										{...(etrDocDetails?.type === 'TRANSFERABLE' && {
											network: `${networkLabel} ${ttStatus === tradeTrustType.unknown && etrDocDetails?.status !== "ISSUANCE_FAILED" ? " (no longer supported)" : ""}`,
											messages: getVerificationStatusArray(verificationFragments)
										})}
									/>
								)}

							{isETRIGPNITRV5FeatureEnabled && (ttStatus !== tradeTrustType.shredded && etrDocDetails?.eventStatus !== "SURRENDER_ACCEPTANCE_APPROVED" || (etrDocDetails?.transferableStores[etrDocDetails?.transferableStores?.length - 1].status === "FAIL" && etrDocDetails?.eventStatus == "SURRENDER_ACCEPTANCE_APPROVED")) && <TokenRegistryDropdown
								tokenRegistryVersion={tokenRegistryVersions.find(option => option.id === etrDocDetails?.tokenRegistryVersion)}
								showDropdownValue={true}
								selectedNetwork={etrDocDetails?.tokenRegistryVersion}
							/>
							}

							{shouldShowNFTInformation() && (
								<>
									<div className="nft_infor_container" data-testid="nft_infor_container" aria-disabled>
										<div className="nft_information_title__margin__btm record_details_title__new nft-info__tooltip">
											{isApprovalScreen && <InfoBadgeFilled />} NFT Information:
											{isApprovalScreen && ["APPROVED", "REJECTED"].includes(etrDocDetails?.status) && <div className="nft-info__tooltip_text record-details-side-panel-tooltip-text">
												<span>Section links are disabled as this is a snapshot of the ETR as they were when the request was initiated.</span>
											</div>}
										</div>
										<div className={`nft_information ${isApprovalScreen && ["APPROVED", "REJECTED"].includes(etrDocDetails?.status) && "nft-information__disabled-container"}`}>
											<NFTInformation />
										</div>
									</div>
									{ttStatus !== tradeTrustType.shredded && (
										<div className="divider"></div>
									)}
									{(isOwnerAndMakerCheckerEnabled || shouldRenderETRMakerCheckerOwner) ? renderMakerCheckerEnabledOwner() : renderOwner()}
									{renderHolder()}
									{isETRIGPNITRV5FeatureEnabled && etrDocDetails?.tokenRegistryVersion === "V5" && checkETRtransferableStoreStatus() && <RemarksComponent
										remarks={etrDocDetails?.transferableStores[etrDocDetails?.transferableStores.length - 1]?.remarks ?? "-"}
										showTextAreaValue={true}
										showBackgroundColor={etrDocDetails?.eventStatus?.includes("PENDING_APPROVAL") || ["PENDING_APPROVAL", "FAIL"].includes(etrDocDetails?.transferableStores[etrDocDetails?.transferableStores?.length - 1]?.status)}
									/>}
									{((profile?.organization?.makerChecker === false || (profile?.organization?.makerChecker === true && profile?.makerCheckerRole === 'MAKER'))) && (ttStatus === "Unknown" || holder === organizationWallet || owner === organizationWallet || action === etrActions.acceptRejectSurrender) && (etrDocDetails?.transferableStores[etrDocDetails?.transferableStores?.length - 1]?.status !== "FAIL" || (etrDocDetails?.eventStatus !== "SURRENDER_ACCEPTANCE_APPROVED" && etrDocDetails?.eventStatus !== "RESTORE_APPROVED")) && <RecordDetailsManageButton />}
								</>
							)}
						</>
					)}

				{![
					null,
					etrActionable.surrender,
					etrActionable.endorseOwner,
				].includes(selectedAction) && (
						<>
							<UpdateWallet
								title="Owner"
								currentWallet={owner}
								addressBook={etrData}
								fetchEtr={fetchEtr}
								addToastMessage={addToastMessage}
								selectedWallet={selectedOwner}
								setSelectedWallet={setSelectedOwner}
								isEditRequest={isEditRequest}
								isSelectable={
									selectedAction ===
									etrActionable.transferOwnerAndHolder ||
									selectedAction === etrActionable.transferOwner
								}
								nominatedBeneficiary={
									nominatedBeneficiary !== emptyAddress
										? nominatedBeneficiary
										: undefined
								}
							/>
							<UpdateWallet
								title="Holder"
								currentWallet={holder}
								addressBook={etrData}
								fetchEtr={fetchEtr}
								addToastMessage={addToastMessage}
								selectedWallet={selectedHolder}
								setSelectedWallet={setSelectedHolder}
								isEditRequest={isEditRequest}
								isSelectable={
									selectedAction ===
									etrActionable.transferOwnerAndHolder ||
									selectedAction === etrActionable.transferHolder
								}
							/>
							{isETRIGPNITRV5FeatureEnabled && etrDocDetails?.tokenRegistryVersion === "V5" && <RemarksComponent
								remarks={remarksForTransfer}
								setRemarks={setRemarksForTransfer}
								placeHolder={"Enter Remarks Here"}
								showTextArea={true}
								showRemarksDivForTransfer={true}
							/>}
							<div className="etr__submit">
								{<Button
									text="Transfer"
									round={true}
									disabled={checkDisabled()}
									loading={submitLoading}
									submit={isEditRequest ? showEditRequestModal : showTransferModal}
								/>}
								{<Button
									text="Cancel"
									nohover
									noborder
									submit={() => {
										resetTransferDetails();
										setIsEditRequest(false);
									}}
								/>}
							</div>
						</>
					)}
			</div>

			<Modal visible={confirmTransferModal} variant="small" close={hideTransferModal}>
				<CardConfigure >
					{renderModalHeaderAndContent()}
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								addClass="etr-maker-checker__modal__cancel"
								text="Cancel"
								nohover
								noborder
								ghost
								submit={() => {
									hideTransferModal()
								}}
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<Button
								warning
								noHover
								round
								text="Confirm"
								submit={() => {
									hideTransferModal()
									ETRMakerCheckerHandleTransfer()
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Modal visible={confirmDiscardModal} variant="small" close={hideDiscardModal}>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon'}>
											<IconIndicator />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Discard Request
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className='etr__modal__content'>
								Are you sure you want to discard failed request?<br />
								All progress will be removed.
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								addClass="etr-maker-checker__modal__cancel"
								text="Cancel"
								nohover
								noborder
								ghost
								submit={() => {
									hideDiscardModal()
								}}
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<Button
								warning
								noHover
								round
								text="Confirm"
								submit={() => {
									hideDiscardModal()
									handleDiscardRequest()
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Modal visible={confirmEditRequestModal} variant="small" close={hideEditRequestModal}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className='card-configure__icon'><WarningIndicator /></div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">Resubmit Request</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className='etr__modal__content'>
								Are you sure you want to resubmit the request ?
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								text="Cancel"
								nohover
								noborder
								ghost
								data-testid="cancel-edit-request"
								submit={() => {
									hideEditRequestModal()
								}}
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<Button
								noHover
								round
								text="Confirm"
								data-testid="confirm-edit-request"
								submit={() => {
									hideEditRequestModal()
									ETRMakerCheckerHandleTransfer()
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Modal visible={editRejectTransferModal} variant='small'>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className="card-configure__approval-screen__icon">
											<IconConfigure />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Edit Record Transfer Rejection
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className='etr__modal__content'>
								<span>This action will revert who has control over the ETR. Ensure the previous owner and holder is informed and agree to this change.</span>
								{etrDocDetails?.tokenRegistryVersion === "V5" && <>
									<div className="etr__modal__content__space"></div>
									<RemarksComponent
										remarks={editRemarks}
										setRemarks={setEditRemarks}
										showTextArea={true}
										showLearnmore={false}
										showRemarksDivForTransfer={true}
										showRemarksInformation={true}
										showExtraRemarksInformation={false}
									/>
								</>}
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								addClass="etr-maker-checker__modal__cancel"
								text="Cancel"
								data-testid="cancel-edit-reject-transfer"
								nohover
								noborder
								ghost
								submit={() => { hideEditRejectTransferModal() }}
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<Button
								text="Confirm"
								warning
								data-testid="confirm-edit-reject-transfer"
								round
								submit={() => {
									handleRejectTransfers(selectedActionForETRTransfer, editRemarks)
									hideEditRejectTransferModal()
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Toast toastList={toastList} />

			{(submitLoading || etrDocBlockchainDetailsLoading) &&
				ReactDOM.createPortal(
					<div className="modal white">
						<div className="loading">
							<img src={assetUrl("/loading.gif")} />
						</div>
					</div>,
					document.body
				)}
		</>
	);
};

RecordDetailsSidePanel.propTypes = {
	etrDocDetails: PropTypes.shape({
		contractAddress: PropTypes.string.isRequired,
		status: PropTypes.string,
		name: PropTypes.string,
		transferableStores: PropTypes.array,
		transferableStore: PropTypes.object,
		eventStatus: PropTypes.string,
		transactionType: PropTypes.string,
		type: PropTypes.string,
		tokenRegistryVersion: PropTypes.string,
		remarks: PropTypes.string,
		networkId: PropTypes.string
	}).isRequired,
	fetchEtrDocumentBlockchainDetails: PropTypes.func.isRequired,
	etrDocBlockchainDetails: PropTypes.shape({
		holder: PropTypes.string,
		owner: PropTypes.string,
		endorsementChain: PropTypes.array,
		nominatedBeneficiary: PropTypes.string,
		ttStatus: PropTypes.string
	}).isRequired,
	etrDocBlockchainDetailsLoading: PropTypes.bool.isRequired,
	etrDocErrorMsg: PropTypes.string,
	isApprovalScreen: PropTypes.bool,
	showBackgroundColor: PropTypes.bool
}
export default RecordDetailsSidePanel;
